import React, { SVGProps } from 'react';

const RaiseSupportIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="RaiseSupportIcon">
    <path
      d="m15.5 10.5-5 4.997-9.165.003a.832.832 0 0 1-.835-.828V1.327C.5.872.87.5 1.327.5h13.345c.457 0 .828.38.828.835V10.5Zm-1.667-8.333H2.167v11.666h6.666V9.667a.833.833 0 0 1 .736-.828l.098-.006h4.166V2.166Zm-.69 8.332L10.5 10.5v2.64l2.643-2.64Z"
      fill="var(--dropdownIconColor)"
      stroke="var(--walletMenuBackground)"
      strokeWidth={0.6}
    />
  </svg>
);

export default RaiseSupportIcon;
